import { useLayoutEffect } from 'react';
import { isWindowAvailable } from 'utils/browser';

export const useClientOnlyLayoutEffect = !isWindowAvailable ? () => {} : useLayoutEffect;
